import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTIconExternalLink } from "commonComponents/btWrappers/BTIcon";

import { type IExternalProductLink, VendorTypes } from "entity/vendor/common/vendor.types";

import "./VendorProductLink.less";

interface IVendorProductLinkProps {
    /**
     * External product link
     */
    productLink?: IExternalProductLink;
    /**
     * Vendor type
     */
    vendorType: VendorTypes;

    /**
     * Data test id
     */
    "data-testid"?: string;
}

const getTestId = (dataTestId: string | undefined, append: string) => {
    return dataTestId && dataTestId + "-" + append;
};

const VendorProductLink: React.FC<IVendorProductLinkProps> = ({
    vendorType,
    "data-testid": dataTestId,
    ...props
}) => {
    if (vendorType === VendorTypes.Unknown || !props.productLink) {
        return null;
    }

    return (
        <div className="VendorProductLink">
            <div>
                <BTExternalLink
                    data-testid={getTestId(dataTestId, "link") ?? ""}
                    href={props.productLink.value}
                    buttonType="link"
                    isolated
                >
                    {props.productLink.label} <BTIconExternalLink />
                </BTExternalLink>
            </div>
            {props.productLink.helpText && (
                <em className="ProductLinkHelpText">{props.productLink.helpText}</em>
            )}
        </div>
    );
};

export default VendorProductLink;
